export const creditoClienteMock = [[
{
    "isSuccess": true,
    "data": [
        [
            {
                "id": 529,
                "codigoVendedor": "00247241",
                "nomeVendedor": "LUCAS TIEGHI",
                "basesCreditoCliente": [
                    {
                        "id": 7,
                        "tag": "Rota",
                        "total": 874634,
                        "outrosCreditos": 874634,
                        "codigo": "836",
                        "clienteId": 67428,
                        "razaoSocial": "SUPERMIX CONCRETO S A",
                        "grupoCentralizador": "SUPERMIX",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 529,
                        "codigoVendedor": "00247241",
                        "nomeVendedor": "LUCAS TIEGHI"
                    },
                    {
                        "id": 985,
                        "tag": "Rota",
                        "total": 136529,
                        "outrosCreditos": 136529,
                        "codigo": "1166457",
                        "clienteId": 4308,
                        "razaoSocial": "MAXTER BLOCOS LTDA",
                        "grupoCentralizador": "LUIZ CARLOS GAVA",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 529,
                        "codigoVendedor": "00247241",
                        "nomeVendedor": "LUCAS TIEGHI"
                    }
                ]
            },
            {
                "id": 1558,
                "codigoVendedor": "277574",
                "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO",
                "basesCreditoCliente": [
                    {
                        "id": 1733,
                        "tag": "Todos",
                        "descontoGerencial": 174.22,
                        "total": 17422,
                        "outrosCreditos": 17247.78,
                        "codigo": "1430710",
                        "clienteId": 19691,
                        "razaoSocial": "ITAPETI COMERCIO DE MATERIAIS PARA",
                        "grupoCentralizador": "ITAPETI",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 1376,
                        "tag": "Rota",
                        "descontoGerencial": 100,
                        "total": 100,
                        "outrosCreditos": 0,
                        "codigo": "1335535",
                        "clienteId": 53915,
                        "razaoSocial": "GULFIER COMERCIO DE MATERIAL DE",
                        "grupoCentralizador": "GULFIER",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 996,
                        "tag": "Rota",
                        "descontoGerencial": 100,
                        "total": 100,
                        "outrosCreditos": 0,
                        "codigo": "1174866",
                        "clienteId": 56431,
                        "razaoSocial": "AGUIA DOURADA MATERIAIS PARA CONSTR",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 693,
                        "tag": "Rota",
                        "descontoGerencial": 240,
                        "total": 240,
                        "outrosCreditos": 0,
                        "codigo": "1064329",
                        "clienteId": 56680,
                        "razaoSocial": "DISTRIBUIDORA FREITAS DE MATERIAIS",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 3430,
                        "tag": "Rota",
                        "total": 4412,
                        "outrosCreditos": 4412,
                        "codigo": "1805660",
                        "clienteId": 58124,
                        "razaoSocial": "EMPREITEIRA MC CARVALHO LTDA",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 3089,
                        "tag": "Rota",
                        "descontoGerencial": 150,
                        "total": 150,
                        "outrosCreditos": 0,
                        "codigo": "1728574",
                        "clienteId": 58534,
                        "razaoSocial": "45 625 573 CARLOS FLORENCIO DA SILV",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 2799,
                        "tag": "Rota",
                        "total": 66179,
                        "outrosCreditos": 66179,
                        "codigo": "1679331",
                        "clienteId": 107787,
                        "razaoSocial": "DEPOSITO DO GAUCHO MATERIAIS DE",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 3214,
                        "tag": "Rota",
                        "descontoGerencial": 154,
                        "total": 154,
                        "outrosCreditos": 0,
                        "codigo": "1762303",
                        "clienteId": 107917,
                        "razaoSocial": "COMERCIAL MORATO MATERIAIS PARA",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 2429,
                        "tag": "Rota",
                        "descontoGerencial": 690.91,
                        "total": 69091,
                        "outrosCreditos": 68400.09,
                        "codigo": "1598715",
                        "clienteId": 110165,
                        "razaoSocial": "ZUM EXPRESS E-COMMERCE LTDA",
                        "grupoCentralizador": "DEPOSITO ZUMKELLER",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 1738,
                        "tag": "Rota",
                        "descontoGerencial": 380.8,
                        "total": 3808,
                        "outrosCreditos": 3427.2,
                        "codigo": "1431999",
                        "clienteId": 110559,
                        "razaoSocial": "DJ MATERIAIS DE CONSTRUCAO LTDA",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 966,
                        "tag": "Rota",
                        "descontoGerencial": 120,
                        "total": 120,
                        "outrosCreditos": 0,
                        "codigo": "1156599",
                        "clienteId": 110888,
                        "razaoSocial": "ALEX SANDRO BARBOSA GOMES",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 938,
                        "tag": "Rota",
                        "descontoGerencial": 497.78,
                        "total": 49778,
                        "outrosCreditos": 49280.22,
                        "codigo": "1148880",
                        "clienteId": 110895,
                        "razaoSocial": "VALE DO ITAPETI COMERCIO E",
                        "grupoCentralizador": "ITAPETI",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 575,
                        "tag": "Rota",
                        "descontoGerencial": 478.8,
                        "total": 4788,
                        "outrosCreditos": 4309.2,
                        "codigo": "1060061",
                        "clienteId": 111145,
                        "razaoSocial": "RICARDO MANIEZO MADEIRAS",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    },
                    {
                        "id": 80,
                        "tag": "Rota",
                        "total": 361414,
                        "outrosCreditos": 361414,
                        "codigo": "1005470",
                        "clienteId": 111991,
                        "razaoSocial": "DEPOSITO DE MATERIAIS PARA",
                        "grupoCentralizador": "DEPOSITO ZUMKELLER",
                        "createdAt": "2026-04-29T16:18:59.2474688",
                        "usuarioId": 1558,
                        "codigoVendedor": "277574",
                        "nomeVendedor": "EZEQUIEL LOPES CAJADO DE ARAUJO"
                    }
                ]
            }
        ]
    ],
    "existentes": []
}
]]